import { InternalMedFormIcon } from "../internal/MedFormIcon.js";
import { useTranslation } from "react-i18next";
import { jsx } from "react/jsx-runtime";

//#region src/components/med-form-icon/variants/MedFormSuppositoryIcon.tsx
const MedFormSuppositoryIcon = (props) => {
	const { t } = useTranslation("phx-lib");
	return /* @__PURE__ */ jsx(InternalMedFormIcon, {
		...props,
		svgFile: "suppository-icon.svg",
		alt: t("medicationForm.suppository")
	});
};

//#endregion
export { MedFormSuppositoryIcon };